$ = require 'jquery'
React = require 'react'
t = require('views/internal/recup-with-helpers')('action')
Dates = require 'lib/dates'
Entity = require './entity-react'
MemberAvatar = require 'views/member/member-avatar-react'
ActivityMemberMenuView = require 'views/member-menu-profile/activity-member-menu-view'
ModelCache = require 'db/model-cache'
Util = require 'lib/util'
PopOver = require 'views/lib/pop-over'

module.exports = class Action extends React.Component
  displayName: "Action"

  constructor: (props) ->
    @viewMemberActionMenu = @viewMemberActionMenu.bind(@)

    super props

  viewMemberActionMenu: (e) ->
    Util.stop(e)

    member = ModelCache.get('Member', $(e.target).closest('[data-idmember]').attr("data-idmember") ? @props.context.member.id)

    if $(e.target).closest('.pop-over').length > 0
      PopOver.pushView
        view: ActivityMemberMenuView
        options:
          model: member
          modelCache: ModelCache

    else
      PopOver.toggle
        elem: $(e.target).closest('.js-show-mem-menu')
        view: ActivityMemberMenuView
        options:
          model: member
          modelCache: ModelCache

    return

  render: t.renderable ->
    { actionData, context, options } = @props
    { entities, saved, dateLastEdited, date, url } = actionData
    { member, board, organization, canReply, canDelete, canEdit, canAttachLink, showMemberFullName, replyUrl } = context
    { useEmbedly, usePreviews, showOptions, fullWidthComment, noPhenomPadding, trackReply, trackTimestamp } = options

    t.div
      class: t.classify('phenom': true, 'mod-no-padding': noPhenomPadding),
      ref: (el) -> Dates.update(el)
    , =>

      t.div '.phenom-creator', =>

        if member
          t.div '.member.js-show-mem-menu', { 'data-idmember': member.id, onClick: @viewMemberActionMenu }, ->
            t.createElement MemberAvatar, member
        else
          t.span '.icon-lg.icon-member'

      t.div '.phenom-desc', =>

        if showMemberFullName && member?.fullName
          t.span '.inline-member.js-show-mem-menu', { 'data-idmember': member.id, onClick: @viewMemberActionMenu.bind(@) }, ->
            t.span '.u-font-weight-bold', ->
              t.text member.fullName

        for entity in entities
          t.createElement Entity, { entity, context, options }

        if useEmbedly
          t.div '.hide.embedly.js-embedly'

        if usePreviews
          t.div '.hide.previews.js-previews'

      t.p '.phenom-meta.quiet', ->
        if saved
          if url
            t.a '.date.past.js-hide-on-sending.js-highlight-link', { 'data-date': date, href: url, onClick: trackTimestamp }
          else
            t.span '.date.past.js-hide-on-sending', { 'data-date': date }
        if dateLastEdited
          t.span '.js-date-title.js-hide-on-sending', { 'data-date': dateLastEdited }, ->
            t.text ' '
            t.format 'edited'
        t.span { class: t.classify('js-spinner': true, hide: saved) }, ->
          t.format 'sending-ellipsis'

        if board
          { boardPLevelAltText, boardPLevelIconClass } = context
          t.text ' - '
          t.format 'on-board-name', { url: board.url, name: board.name, boardPLevelAltText, boardPLevelIconClass }

        if organization
          { orgPLevelAltText, orgPLevelIconClass } = context
          t.text ' - '
          t.format 'on-organization-name', { url: organization.url, name: organization.name, orgPLevelAltText, orgPLevelIconClass }

        if showOptions
          t.span '.js-hide-on-sending', ->
            if canReply
              t.text " - "
              t.a '.js-reply-to-action', { href: "#{ if replyUrl then replyUrl else '#' }", onClick: trackReply }, ->
                t.format 'reply'
            if canEdit
              t.text " - "
              t.a '.js-edit-action', { href: '#' }, ->
                t.format 'edit'
            if canAttachLink
              t.text " - "
              t.a '.js-attach-link', { href: '#' }, ->
                t.format 'attach link'
            if canDelete
              t.text " - "
              t.a '.js-confirm-delete-action', { href: '#' }, ->
                t.format 'delete'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/action-react.coffee